<div class="app-root-container">
<mat-drawer-container class="app-component mat-app-background" mat-app-background class="main-container">
  <router-outlet></router-outlet>
</mat-drawer-container>
</div>

